import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import { getUserData } from '../../selectors/user';
import { isFreeTierOrTrial } from '../utils';
import css from '../style.css';

function IntercomBell() {
    const userData = useSelector(getUserData) || {};
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (window.Intercom) {
            window.Intercom('onUnreadCountChange', count => setUnreadCount(count));
        }
    }, []);

    if (!userData.email || isFreeTierOrTrial(userData)) {
        return null;
    }

    return (
        <button type="button" id="intercom-link" className={css.iconButton} aria-label="notifications">
            <Icon
                name={unreadCount > 0 ? 'bell-ringing' : 'bell'}
                size={IconSizes.SMALL}
                variant={unreadCount > 0 ? IconVariants.ERROR : IconVariants.WHITE}
            />
        </button>
    );
}

export default IntercomBell;
